import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import type { Positioning } from 'src/app/models/cluster.model';
import { POSITIONING_LABELS } from 'src/app/models/onboarding.labels';

@Component({
  selector: 'app-positioning-selector',
  imports: [CommonModule],
  template: `
    <div class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-gray-200 dark:border-slate-700">
      <h3 class="text-sm font-bold mb-2 text-gray-900 dark:text-white">
        📊 Positionnement tarifaire
      </h3>
      <div class="grid grid-cols-3 gap-2">
        @for (option of positioningOptions; track option) {
          <button
            type="button"
            (click)="select(option.key)"
            class="p-2 rounded-lg border transition-all text-center"
            [ngClass]="{
              'bg-blue-50 dark:bg-blue-900/20 border-blue-500 text-blue-900':
                selectedPositioning() === option.key,
              'bg-gray-50 dark:bg-slate-900 border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-300 hover:border-blue-300':
                selectedPositioning() !== option.key,
            }"
          >
            <div class="font-semibold text-xs">
              {{ option.icon }} {{ option.label }}
            </div>
            <div class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">
              {{ option.description }}
            </div>
          </button>
        }
      </div>
    </div>
  `,
})
export class PositioningSelectorComponent {
  readonly selectedPositioning = input<Positioning>('standard');
  readonly positioningChange = output<Positioning>();

  positioningOptions = Object.entries(POSITIONING_LABELS).map(
    ([key, config]) => ({
      key: key as Positioning,
      ...config,
    }),
  );

  select(value: Positioning): void {
    this.positioningChange.emit(value);
  }
}
